








import Vue from 'vue'
export default Vue.extend({
  name: 'UiSwitch',
  props: {
    text: String,
    value: Boolean
  },
  methods: {
    onInput (event: boolean) {
      this.$emit('input', event)
    },
    toggleValue () {
      this.onInput(!this.currentValue);
    }
  },
  computed: {
    currentValue: {
      get (): boolean {
        return this.value as boolean
      },
      set () {
      }
    }
  }
})
